import { apiService } from '../axiosAuth';

const apiUrl = window.env.APP_BROKERFRONT_BACKEND_URI;

export const getBrokerProducts = (recommendationCode) =>
  apiService
    .get(`${apiUrl}/api/frontend/partner-configuration/recommendation-code/${recommendationCode}/products`)
    .then(({ data }) => data);

export const getBrokerProductSummary = (recommendationCode, product) =>
  apiService.get(`${apiUrl}/api/frontend/automatic-integration/recommendation-code/${recommendationCode}/summary/product/${product}`);

export const postBrokerProductSecret = (recommendationCode, product, password) =>
  apiService.post(
    `${apiUrl}/api/frontend/automatic-integration/recommendation-code/${recommendationCode}/summary/product/${product}/prod-access`,
    {
      password,
    }
  );

export const postBrokerActivation = (recommendationCode, params) =>
  apiService.post(`${apiUrl}/api/frontend/automatic-integration/recommendation-code/${recommendationCode}`, params);

export const postBrokerProductStyle = (recommendationCode, data) =>
  apiService.post(`${apiUrl}/api/frontend/automatic-integration/recommendation-code/${recommendationCode}/styles`, data);

export const putBrokerProductStyle = (recommendationCode, styleId, data) =>
  apiService.put(`${apiUrl}/api/frontend/automatic-integration/recommendation-code/${recommendationCode}/styles/${styleId}`, data);
